"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationService = void 0;
var NotificationMessages_1 = require("../constants/NotificationMessages");
var CommonService_decorator_1 = require("../../core/decorators/CommonService.decorator");
var NotificationService = /** @class */ (function () {
    function NotificationService($NoticationStaticInstance, callbacks, isInitOk) {
        if (callbacks === void 0) { callbacks = []; }
        if (isInitOk === void 0) { isInitOk = false; }
        this.$NoticationStaticInstance = $NoticationStaticInstance;
        this.callbacks = callbacks;
        this.isInitOk = isInitOk;
    }
    NotificationService.prototype.getNotificationService = function () {
        var _this = this;
        return {
            initSignalR: this.initSignalR,
            isInitOk: this.isInitOk,
            registerCallback: {
                addCallback: this._addCallback.bind(this),
                removeCallback: this._removeCallback.bind(this),
            },
            callbacks: this.callbacks,
            initSignalRService: function () {
                Object.assign(_this.$NoticationStaticInstance, {
                    notificationHub: $.connection.notificationHub,
                });
            },
        };
    };
    NotificationService.prototype.initSignalR = function (options) {
        var _this = this;
        if (this.isInitOk)
            return;
        Object.assign(this.$NoticationStaticInstance.notificationHub.client, {
            onReceiveUpdateVersionMessage: function (msg) {
                console.info('signalR:new version update', msg);
                _this.runCallBack(NotificationMessages_1.NOTIFICATION_MESSAGE.NewVersion, msg);
            },
            onReceiveNewVersionMessage: function (msg) {
                console.info('signalR:new version created', msg);
                _this.runCallBack(NotificationMessages_1.NOTIFICATION_MESSAGE.NewVersion, msg);
            },
            onReceiveNewFolderMessage: function (msg) {
                console.info('signalR:new folder created', msg);
                _this.runCallBack(NotificationMessages_1.NOTIFICATION_MESSAGE.Created, msg);
            },
            onReceiveMoveContentsMessage: function (msg) {
                console.info('signalR:onReceiveMoveContentsMessage', msg);
                _this.runCallBack(NotificationMessages_1.NOTIFICATION_MESSAGE.Moved, msg);
            },
            onReceiveCopyContentsMessage: function (msg) {
                console.info('signalR:onReceiveCopyContentsMessage', msg);
                _this.runCallBack(NotificationMessages_1.NOTIFICATION_MESSAGE.Copy, msg);
            },
            onReceiveDeleteContentMessage: function (msg) {
                console.info('signalR:onReceiveDeleteContentMessage', msg);
                _this.runCallBack(NotificationMessages_1.NOTIFICATION_MESSAGE.Deleted, msg);
            },
            onReceiveContentStatusChangeMessage: function (msg) {
                console.info('signalR:content status changed', msg);
                _this.runCallBack(NotificationMessages_1.NOTIFICATION_MESSAGE.NewStatus, msg);
            },
            onReceiveNewShortcutMessage: function (msg) {
                console.info('shortcut added', msg);
                _this.runCallBack(NotificationMessages_1.NOTIFICATION_MESSAGE.AddShortcut, msg);
            },
            onReceiveRemoveShortcutMessage: function (msg) {
                console.info('shortcut removed', msg);
                _this.runCallBack(NotificationMessages_1.NOTIFICATION_MESSAGE.RemoveShortcut, msg);
            },
            onReceiveShared2CollaboratorsMessage: function (msg, collaborators) {
                msg.collaborators = collaborators;
                console.info('onReceiveShared2CollaboratorsMessage', msg);
                _this.runCallBack(NotificationMessages_1.NOTIFICATION_MESSAGE.Shared2Collaborators, msg);
            },
            onReceiveUnshared2CollaboratorsMessage: function (msg, collaborators) {
                msg.collaborators = collaborators;
                console.info('onReceiveUnshared2CollaboratorsMessage', msg);
                _this.runCallBack(NotificationMessages_1.NOTIFICATION_MESSAGE.Unshared2Collaborators, msg);
            },
            onReceiveCollaboratorRoleUpdatedMessage: function (msg, collaborators) {
                msg.collaborators = collaborators;
                console.info('onReceiveCollaboratorRoleUpdatedMessage', msg);
                _this.runCallBack(NotificationMessages_1.NOTIFICATION_MESSAGE.CollaboratorRoleUpdated, msg);
            },
            onReceiveNewNoteMessage: this.onReceiveNewNoteMessage,
            onReceiveRenameContentMessage: function (msg) {
                console.info('signalR:content name changed', msg);
                _this.runCallBack(NotificationMessages_1.NOTIFICATION_MESSAGE.Rename, msg);
            },
            onReceiveLockContentMessage: function (msg) {
                console.info('signalR:content locked', msg);
                _this.runCallBack(NotificationMessages_1.NOTIFICATION_MESSAGE.Locked, msg);
            },
            onReceiveUnlockContentMessage: function (msg) {
                console.info('signalR:content unlocked', msg);
                _this.runCallBack(NotificationMessages_1.NOTIFICATION_MESSAGE.Unlocked, msg);
            },
            onReceiveRemoveNoteMessage: function (msg, note) {
                console.info('signalR:content remove comments', msg, note);
                msg.note = note;
                _this.runCallBack(NotificationMessages_1.NOTIFICATION_MESSAGE.RemoveComments, msg);
            },
            onReceiveSetAsCurrentVersionMessage: function (msg) {
                console.info('signalR:content set as current version', msg);
                _this.runCallBack(NotificationMessages_1.NOTIFICATION_MESSAGE.SetAsCurrentVersion, msg);
            },
            onConvertRevrtMessage: function (msg) {
                console.info('signalR:content convert to pdf or revert to ppt', msg);
                if (NotificationMessages_1.CollaborationActivityType.ConvertDocument === msg.ActionType) {
                    _this.runCallBack(NotificationMessages_1.NOTIFICATION_MESSAGE.Convert2PDF, msg);
                }
                else if (NotificationMessages_1.CollaborationActivityType.RevertDocument === msg.ActionType) {
                    _this.runCallBack(NotificationMessages_1.NOTIFICATION_MESSAGE.Revert2PPT, msg);
                }
            },
            /**
             * onReceiveRefreshFolderMessage is not called
             */
            onReceiveRefreshFolderMessage: function (msg) {
                console.info('signalR:refresh Folder ', msg);
                _this.runCallBack(NotificationMessages_1.NOTIFICATION_MESSAGE.ReceiveRefreshFolderMessage, msg);
            },
            onReceiveChannelNewPublishMsg: function (msg) {
                console.info('signalR:story published ', msg);
                _this.runCallBack(NotificationMessages_1.NOTIFICATION_MESSAGE.StoryPublished, msg);
            },
            onReceiveInstanceName: function (requestId, instanceName) {
                console.info('signalR:liveDoc generate instanceName ', requestId, instanceName);
                _this.runCallBack(NotificationMessages_1.NOTIFICATION_MESSAGE.ReceiveInstanceName, {
                    requestId: requestId,
                    instanceName: instanceName,
                });
            },
            onReceiveGenerationSucceededResult: function (requestId) {
                console.info('signalR:liveDoc generate success ', requestId);
                _this.runCallBack(NotificationMessages_1.NOTIFICATION_MESSAGE.ReceiveGenerationSucceededResult, { requestId: requestId });
            },
            onReceiveGenerationFailedResult: function (requestId, errMsg) {
                console.info('signalR:liveDoc generate failed ', requestId, errMsg);
                _this.runCallBack(NotificationMessages_1.NOTIFICATION_MESSAGE.ReceiveGenerationFailedResult, {
                    requestId: requestId,
                    errMsg: errMsg,
                });
            },
        });
        var opts = options || {};
        $.connection.hub.qs = { seismicuserid: opts.userId, seismictenant: opts.tenant };
        $.connection.hub.url = opts.signalrMicroServiceHost + '/signalr';
        $.connection.hub
            .start()
            .done(function () {
            console.info('signalR connected');
        })
            .fail(function () {
            console.info('cannot connect to signalR');
        });
        $.connection.hub.disconnected(function () {
            console.log('SignalR disconnected');
            setTimeout(function () {
                $.connection.hub
                    .start()
                    .done(function () {
                    console.info('signalR connected');
                })
                    .fail(function () {
                    console.info('cannot connect to signalR');
                });
            }, 500); // Restart connection after 5 seconds.
        });
        this.isInitOk = true;
    };
    NotificationService.prototype.runCallBack = function (actionName, msg) {
        if (this.callbacks && this.callbacks.length > 0) {
            this.callbacks.forEach(function (callback) {
                callback(actionName, msg);
            });
        }
    };
    NotificationService.prototype._addCallback = function (fun) {
        this.callbacks.push(fun);
    };
    NotificationService.prototype._removeCallback = function (fun) {
        // tslint:disable-next-line:triple-equals
        this.callbacks = this.callbacks.filter(function (itm) { return itm != fun; });
    };
    NotificationService.prototype.onReceiveNewNoteMessage = function (msg, note) {
        if (msg instanceof Object) {
            console.info('signalR:content new comments', msg);
            Object.assign(msg, {
                note: note,
            });
            this.runCallBack(NotificationMessages_1.NOTIFICATION_MESSAGE.NewComments, msg);
        }
        else {
            console.log('new note added');
            this.runCallBack(NotificationMessages_1.NOTIFICATION_MESSAGE.NewNote, { parentId: msg, noteInfo: note });
        }
    };
    NotificationService = __decorate([
        CommonService_decorator_1.CommonService('NotificationService'),
        __metadata("design:paramtypes", [Object, Array, Object])
    ], NotificationService);
    return NotificationService;
}());
exports.NotificationService = NotificationService;
//# sourceMappingURL=Notification.service.js.map